module.exports = __webpack_public_path__ + "img/mystep_lpgo.ab0b5701.svg";